import { useTranslations } from '@power-core/toolkit';
import { type FunctionComponent, useState } from 'react';

import { Button } from '@/ui-components/button/button';
import { Flexbox } from '@/ui-components/flexbox/flexbox';
import { Input } from '@/ui-components/input/input';
import { useCustomerApi } from '../hooks/use-customer-api';

export const NewCustomerRow: FunctionComponent<{ setIsNew: React.Dispatch<React.SetStateAction<boolean>> }> = ({ setIsNew }) => {
	const t = useTranslations();
	const { createCustomer } = useCustomerApi();
	const [newCustomerName, setNewCustomerName] = useState('');
	const [error, setError] = useState({ message: '', details: '' });

	const handleCreateButtonClick = () => {
		createCustomer
			.mutateAsync({ name: newCustomerName })
			.then(() => {
				setIsNew(false);
				setNewCustomerName('');
			})
			.catch((err) => {
				setError({ message: t(err.response.data.error.message), details: '' });
			});
	};

	const handleCancelButtonClick = () => {
		setIsNew(false);
		setNewCustomerName('');
	};

	return (
		<Flexbox direction='col' className='pb-5'>
			<hr className='border-t-2 my-2.5 border-n300_table_background' />
			<Flexbox className='gap-4 p-0.5 pr-1.5 items-baseline' justify='between'>
				<Input
					name='customerName'
					sizing='small'
					value={newCustomerName}
					placeholder={t('T_ENTER_CUSTOMER_NAME')}
					onChange={(e) => setNewCustomerName(e.target.value)}
					containerClassname='w-64'
					error={error.message}
				/>
				<Flexbox className='gap-1'>
					<Button variant='text' sizing='small' onClick={handleCreateButtonClick} className='font-normal text-sm w-fit text-accent'>
						{t('T_SAVE')}
					</Button>
					<Button variant='text' sizing='small' onClick={handleCancelButtonClick} className='font-normal text-sm w-fit text-brand'>
						{t('T_CANCEL')}
					</Button>
				</Flexbox>
			</Flexbox>
		</Flexbox>
	);
};
